<template>
  <div style="height:100%;">
    <div ref="refTitleBar" class="position-relative">
      <base-nav type="default" effect="dark" expand style="height: 50px;">
        <base-button title="Toggle Fullscreen" type="primary" @click="switch_fullscreen()">
          <i class="fa fa-clone" aria-hidden="true"></i>
        </base-button>

        <h5 class="case-title" style="padding-left: 60px">
          {{ meeting.case_id }} {{ meeting.case_description }}
        </h5>
      </base-nav>
    </div>

    <div ref="refMeetArea" class="position-relative" style="height:calc(100% - 50px); ">
      <section class="section-shaped my-0" style="height:100%;">
        <div class="container-fluid shape-container d-flex" style="height:100%;">
          <div class="col px-0" style="height:100%;">
            <div class="row" style="height:100%;">
              <div class="div-nav" :class="{
                'menu-width-menu-enable': is_show,
                'menu-width-menu-disable': !is_show,
              }"></div>
              <div :class="{
                'setup-message-show': !is_jitsi_show,
                'setup-message-hide': is_jitsi_show,
              }">
                <section class="section section-shaped section-lg my-0">
                  <div class="shape shape-style-1 bg-gradient-default">
                    <span></span>
                  </div>
                  <div class="container pt-lg-md">
                    <div class="row justify-content-center">
                      <div class="col-lg-11">
                        <card type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                          <template>
                            <div class="text-center text-muted mb-4">
                              <h3>
                                Remote meeting setup in progress...
                              </h3>
                              <h6>
                                The browser may ask for your approval for the
                                access to microphone and camera.
                              </h6>
                              <h6>Please approve.</h6>
                            </div>
                          </template>
                        </card>
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              <div class="iframe-div" :class="{
                'jitsi-width-menu-enable': is_show,
                'jitsi-width-menu-disable': !is_show,
                'jitsi-show': is_jitsi_show,
                'jitsi-hide': !is_jitsi_show,
              }">
                <div id="meet" class="iframe-container" v-show="is_jitsi_show">
                  <p v-if="is_showWaterMark" class="watermark" style="top:8%; left:2%;">{{ watermarkstr }}</p>
                  <p v-if="is_showWaterMark" class="watermark" style="top:24%; right:24%;">{{ watermarkstr }}</p>
                  <p v-if="is_showWaterMark" class="watermark" style="bottom:24%; left:24%;">{{ watermarkstr }}</p>
                  <p v-if="is_showWaterMark" class="watermark" style="bottom:8%; right:2%;">{{ watermarkstr }}</p>

                  <p v-if="is_showWaterMark" class="watermark" style="top:36%; left:24%;">{{ watermarkstr }}</p>
                  <p v-if="is_showWaterMark" class="watermark" style="bottom:36%; right:24%;">{{ watermarkstr }}</p>
                  <p v-if="is_showWaterMark" class="watermark" style="top:48%; left:2%;">{{ watermarkstr }}</p>
                  <p v-if="is_showWaterMark" class="watermark" style="bottom:48%; right:2%;">{{ watermarkstr }}</p>
  
                </div>
              </div>
            </div>
            </div>
          </div>
      </section>
    </div>


  </div>
</template>
<script src="https://meet.jit.si/external_api.js"></script>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import screenfull from "screenfull";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "Participant",
  computed: {
    menu_caption() {
      if (this.is_show) {
        return "Hide Menu";
      } else {
        return "Show Menu";
      }
    },
  },
  created() {
    window.addEventListener("beforeunload", this.close_browser);
    screenfull.onchange(this.onFullScreenChg);
    /*
    screenfull.onchange(()=>{
  console.log("fullscreen = "+screenfull.isFullscreen);
    }
    

    );*/
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.close_browser);
    if (this.on_participantLeft_timeout.length > 0) {
      for (let i in this.on_participantLeft_timeout) {
        console.log("clear on_participantLeft_timeout " + i);
        clearTimeout(this.on_participantLeft_timeout[i]);
      }
    }
    if (this.check_meeting_end_interval) {
      clearInterval(this.check_meeting_end_interval);
    }
  },
  data() {
    return {
      //numShown:0,
      is_showWaterMark:false,
      is_show: false,
      is_jitsi_show: false,
      status: null,
      meeting: this.$route.params.meeting,
      on_participantLeft_timeout: [],
      api: null,
      check_meeting_end_interval: null,
      watermarkstr:"",
      
    };
  },
  methods: {
    /*
    showDisplayName(dna){
      if(this.numShown>3){
        return;
      }
      this.numShown++;
        this.api.executeCommand('displayName', dna);
        console.log("show display name "+this.numShown+" :"+dna);
        setTimeout(this.showDisplayName(dna),3);

    },
    */
   get_global_config() {
      console.log("get_global_config");
      axios
        .post(process.env.VUE_APP_WEB_HOST + "/config/get_global_config", {
          case_id: "",
        })
        .then((res) => {
          console.log(res.data);
          if(res.data.SHOW_WATERMARK01=="1") {
            this.is_showWaterMark=true;
          }else{
            this.is_showWaterMark=false;
          }
          //console.log("******* set is_showWaterMark call join_meeting "+this.is_showWaterMark);
          this.join_meeting(this.meeting);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    close_browser(e) {
      var confirmationMessage = "\o/";

      (e || window.event).returnValue = confirmationMessage; //Gecko + IE
      return confirmationMessage; //Webkit, Safari, Chrome
    },
    switch_fullscreen() {
      if (screenfull.isEnabled) {
        screenfull.toggle();
        //screenfull.toggle(document.querySelector("#meet"));
      }
    },
    onFullScreenChg(){
      console.log("fullscreen = "+screenfull.isFullscreen);
      
      if(screenfull.isFullscreen){
        this.$refs.refTitleBar.style.display="none";
        //this.$refs.refTitleBar.style.zIndex="100";
        this.$refs.refMeetArea.style.top="0";
        //this.$refs.refMeetArea.style.zIndex="0";
        this.$refs.refMeetArea.style.height="100%"
      }else{
        this.$refs.refTitleBar.style.display="block";
        //this.$refs.refTitleBar.style.zIndex=0;
        this.$refs.refMeetArea.style.top="50";
        this.$refs.refMeetArea.style.height="calc(100% - 50px)"
      }
      
    },
    onMouseMove(evt){
      if(screenfull.isFullscreen){
      if(evt.event.clientY<=60){
        this.$refs.refTitleBar.style.display="block";
        this.$refs.refMeetArea.style.top="50";
        this.$refs.refMeetArea.style.height="calc(100% - 50px)"
      }else {
        this.$refs.refTitleBar.style.display="none";
        this.$refs.refMeetArea.style.top="0";
        this.$refs.refMeetArea.style.height="100%"
      }
      }
    },
    /*
    onToolbarButtonClicked(evt){
      console.log(evt.key,evt.preventExecution);

    },
    */
    join_meeting(meeting) {
      //console.log("join_meeting"+ JSON.stringify(meeting));
      console.log("join_meeting");
      console.log("jitsi_app_dest:" + meeting.jitsi_app_dest);
      const domain = meeting.jitsi_app_dest;

      let displayName = meeting.name;

      if (meeting.input_name) {
        displayName = displayName + " [" + meeting.input_name + "]";
      }

      if(meeting.configs.SHOW_WATERMARK01=="1") {
            this.is_showWaterMark=true;
          }else{
            this.is_showWaterMark=false;
          }  

      const options = {
        roomName: meeting.meeting_id,
        width: "100%",
        height: "100%",
        //jwt: 'oAkyUh5CWVqEP2LmxxMG',
        //password: meeting.jitsi_room_password,
        parentNode: document.querySelector("#meet"),
        configOverwrite: { 
          prejoinConfig: {    
            enabled: false,  
          },
          toolbarButtons: [
            'camera',
            'desktop',
            'fullscreen',
            'hangup',
            'microphone',
            'mute-everyone',
            'raisehand',
            'select-background',
            'settings',
            'shortcuts',
            'stats',
            'tileview',
            'videoquality',
            '__end'
          ], 
          /*
          buttonsWithNotifyClick: [
            {
              key: 'fullscreen',
              preventExecution: false
            },
        //'fullscreen',
          ],
          */
      
     },
        userInfo: {
          displayName: displayName,
        },
        endofjson: true,
      };
      //console.log("******* add fullscreen")
      //if(!this.is_showWaterMark){
        //options.configOverwrite.toolbarButtons.splice(2,0,"fullscreen");
      //}
      if(this.is_showWaterMark){
      let ix = options.configOverwrite.toolbarButtons.indexOf("fullscreen");
if (ix > -1) { // only splice array when item is found
  options.configOverwrite.toolbarButtons.splice(ix, 1); // 2nd parameter means remove one item only
}
      }
      if(meeting.allow_virtualbackground==0){
      let ix = options.configOverwrite.toolbarButtons.indexOf("select-background");
if (ix > -1) { // only splice array when item is found
  options.configOverwrite.toolbarButtons.splice(ix, 1); // 2nd parameter means remove one item only
}
      }


      this.api = new JitsiMeetExternalAPI(domain, options);
      //this.api.addEventListener("toolbarButtonClicked",this.onToolbarButtonClicked);
      this.api.addEventListener("mouseMove",this.onMouseMove);



      //this.is_jitsi_show = true;
      
      console.log("debug** new JitsiMeetExternalAPI");

      this.api.on("passwordRequired", () => {
        console.log("debug** on passwordRequired");
        this.api.executeCommand("password", meeting.jitsi_room_password);
        this.api.executeCommand("subject", meeting.case_id);
        
        
        //////////////////////////////
        
        let dName = meeting.name;
        if (meeting.input_name) {
          dName = dName + " [" + meeting.input_name + "]";
        }
        //this.api.executeCommand('displayName', dName+"yyyyyyyyyyyyyyy");
        
        /////////////////////////////


        console.log("debug** after passwordRequired");

        setTimeout(() => {
          this.is_jitsi_show = true;
          this.check_meeting_end_interval = setInterval(
            this.check_meeting_end,
            60 * 1000
          );


/////////////////
        this.api.executeCommand('displayName', dName);
        console.log(new Date()+ " Show display name 1/3 "+dName);
        setTimeout(()=>{
          this.api.executeCommand('displayName', dName);
          console.log(new Date()+ " Show display name 2/3 "+dName);
          setTimeout(()=>{
            this.api.executeCommand('displayName', dName);
            console.log(new Date()+ " Show display name 3/3 "+dName);
            },3000);

          },3000);
        /*
        let dName = meeting.name;
        if (meeting.input_name) {
          dName = dName + " [" + meeting.input_name + "]";
        }
        this.api.executeCommand('displayName', dName);
        */
/////////////////////////////
/*
<iframe allow="camera; microphone; display-capture; autoplay; clipboard-write" src="https://juat01.vc.judiciary.hk/FQLAdHQRyfNYborwGNcxZdsGDXqnTdAlUbDkKPzKiHNIZteRcXLzaTYPVyBWHdVpSnTKtrwBfrgyaugetJjyvIimOLOChUlchOmy#jitsi_meet_external_api_id=2&amp;config.prejoinConfig=%7B%22enabled%22%3Afalse%7D&amp;userInfo.displayName=%22s3_hc_1%20%5Babc%5D%22&amp;appData.localStorageContent=null" name="jitsiConferenceFrame2" id="jitsiConferenceFrame2" allowfullscreen="true" style="height: 100%; width: 100%; border: 0px;"></iframe>
<p class="watermark" style="top:8%; left:2%;">{{meeting.name}}</p>
<p class="watermark" style="top:24%; right:24%;">{{meeting.name}}</p>
<p class="watermark" style="bottom:24%; left:24%;">{{meeting.name}}</p>
<p class="watermark" style="bottom:8%; right:2%;">{{meeting.name}}</p>
https://stackoverflow.com/questions/21795761/insert-content-into-iframe
*/
//var doc = document.getElementById('jitsiConferenceFrame2');
//var doc = document.getElementById('meet').children[0];

  //alert(doc.name)
//var ifrDoc = doc.contentDocument;
//ifrDoc = doc.document;
//var ifrDoc = doc.contentWindow.document;
//var ifrDoc=this.api._frame.contentWindow.document;
//alert("ifrDoc="+ifrDoc)
 //var elem = ifrDoc.createElement("div");
 //var elem = doc.createElement("div");
 //elem.textContent = "xxxxxxxxxx";
  //elem.style.top = "8%";
  //elem.style.left = "2%";
  //elem.position="absolute" ;
  //elem.fontSize="2em" ;
  //elem.color= "rgba(0, 0, 0, 1)";
  //elem.zIndex="1000" ;
 //doc.appendChild(elem);


        }, 3000);
      });
      let on_participantLeft = this.on_participantLeft;
      this.api.on("participantLeft", function(data) {
        console.log("participantLeft id: " + data.id);
        on_participantLeft(data.id);
      });
      this.api.on("readyToClose", () => {
        console.log("push end meeting");

        this.$router.push({
          name: "EndMeeting",
          params: {
            case_id: this.meeting.case_id,
            title:
              "You have left the remote meeting of " +
              this.meeting.case_id +
              ".",
            message: ["You have logged out from the system."],
          },
        });
      });
    },
    check_meeting_end() {
      axios
        .post(process.env.VUE_APP_WEB_HOST + "/meeting/get_status", {
          case_id: this.meeting.case_id,
        })
        .then((res) => {
          console.log(res.data);

          if (res.data["status"] && res.data["status"] == "ended") {
            this.$router.push({
              name: "EndMeeting",
              params: {
                case_id: this.meeting.case_id,
                title:
                  "The meeting of " +
                  this.meeting.case_id +
                  " ends.",
                message: ["You have logged out from the system."],
              },
            });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    on_participantLeft(id) {
      console.log("my user id:" + this.api._myUserID + " left id: " + id);

      let timeout_id = setTimeout(this.check_meeting_end, 5000);

      this.on_participantLeft_timeout.push(timeout_id);
      console.log(
        "on_participantLeft_timeout length:" +
          this.on_participantLeft_timeout.length
      );
    },
  },
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
  mounted() {
    console.log("mounted");
    this.watermarkstr= this.meeting.name+" "+(new Date()).toISOString().split('T')[0];
    //this.get_global_config();
    this.join_meeting(this.meeting);
    
  },
};
</script>
<style scoped>
.watermark {
  position: absolute;
  font-size: 1.75em;
  /*color: rgba(0, 0, 0, 1);*/
  color: rgba(225, 225, 225, 0.1);
  font-weight: 300;
  line-height: 1.7;
  z-index: 1000;
  pointer-events: none;
}

.case-title {
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* number of lines to show */
  -webkit-box-orient: vertical;
  word-wrap: break-word;
}

.div-nav {
  background-color: #f4f5f7;
  height: 100%;
}

.menu-width-menu-enable {
  width: 250px;
  display: block;
}

.jitsi-width-menu-enable {
  width: calc(100% - 250px);
}

.menu-width-menu-disable {
  width: 0px;
  display: none;
}

.jitsi-width-menu-disable {
  width: 100%;
}

.setup-message-show {
  display: block;
  width: 100%;
}

.setup-message-hide {
  display: none;
}

.jitsi-show {
  display: block;
}

.jitsi-hide {
  display: none;
}

.iframe-div {
  padding-left: 0px;
  padding-right: 0px;
}

.iframe-container {
  /* position: relative;
  overflow: hidden;
  width: 100%; */
  height: 100%;
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  /* position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%; */
  height: 100%;
}
</style>
